import React from "react";
// @ts-ignore
import { moment } from "cwb-react";
import CloseBackground from "../../../images/close-bg.svg";
import CloseIcon from "../../../images/close-x.svg";
import PlayIcon from "../../../images/play-white.svg";
import { withI18n } from "react-i18next";
import styled from "styled-components";

const VideoDirection = (props: {
  t?: any;
  url: string;
  fileName: string;
  polaroid: string;
  isPending: boolean;
  date: string;
  open: boolean;
  onClickPlayVideo: (url: string) => void;
  videoDirectionId?: number;
  onDeleteVideoDirection: (videoDirectionId: number) => void;
  pastAudition: boolean;
}) => {
  const {
    t,
    url,
    fileName,
    polaroid,
    isPending,
    date,
    onClickPlayVideo,
    videoDirectionId,
    onDeleteVideoDirection,
    pastAudition,
  } = props;

  return (
    <>
      {/* <PlayerModal open={open} toggleModal={toggleModal} url={src} /> */}
      <div className="wrapper">
        <StyledImg src={PlayIcon} onClick={() => onClickPlayVideo(url)} />

        <img
          alt="video thumbnail"
          src={polaroid}
          className="uploaded-img"
          onClick={() => onClickPlayVideo(url)}
        />
        {!pastAudition && (
          <StyledSpan
            className="close"
            onClick={() => onDeleteVideoDirection(videoDirectionId)}
          >
            <img alt="background" src={CloseBackground} />
            <img alt="close" src={CloseIcon} />
          </StyledSpan>
        )}
        <FileNameDiv onClick={() => onClickPlayVideo(url)}>
          {fileName}
        </FileNameDiv>
        {isPending ? (
          <PendingDiv>{t("Uploaded")}</PendingDiv>
        ) : (
          <DateDiv>{moment.moment(date).format("LL")}</DateDiv>
        )}
      </div>
    </>
  );
};

export default withI18n()(VideoDirection);

const StyledImg = styled.img`
  width: 28%;
  height: 28%;
  position: absolute;
  top: 22%;
  left: 35%;
  cursor: pointer;
  object-fit: contain;
`;

const PendingDiv = styled.div`
  background-color: #fcb704;
  border-radius: 3px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  color: #0a1f44;
  padding: 4px 5px 0.5px;
  width: 100px;
  margin-left: 5px;
  font-size: 12px;
`;

const FileNameDiv = styled.div`
  padding-left: 5px;
  color: #364866;
  font-size: 14px;
  width: 164px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

const DateDiv = styled.div`
  padding-left: 5px;
  text-transform: uppercase;
  color: #8a94a6;
  font-size: 11px;
`;

const StyledSpan = styled.span`
  margin-top: 5px;

  & > img {
    position: absolute;
    top: 0;
    right: 0;

    &:last-child {
      padding: 3px;
    }
  }
`;
